import React from 'react';
import { Show, SimpleShowLayout, TextField } from 'react-admin';

const EtiquetasShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="descripcion" />
    </SimpleShowLayout>
  </Show>
);

export default EtiquetasShow;
